import { track } from '@crunchyroll/cr-static-shared-components'

const windowIsReady = typeof window !== 'undefined'

const baseEventDetail = {
  eventSource: 'cr_games_all',
}

const isInActionDetail = false

const basePanelEventDetail = {
  containerRepresentation: 'grid',
  contextType: 'games_website',
  episodeNumber: null,
  episodeTitle: null,
  feedTitle: 'games_website',
  feedType: 'game',
  mediaId: null,
  mediaType: 'game',
  screenName: 'games_website',
}

export const trackPanelSelection = (trackDetail) => {
  if (windowIsReady) {
    track(
      'Panel Selected',
      {
        ...baseEventDetail,
        ...basePanelEventDetail,
        ...trackDetail,
      },
      isInActionDetail
    )
  }
}

export const trackCtaClick = (trackDetail) => {
  if (windowIsReady) {
    track(
      'CTA Clicked',
      {
        ...baseEventDetail,
        ...trackDetail,
      },
      isInActionDetail
    )
  }
}

export const trackGeneralEvent = (event, trackDetail) => {
  if (windowIsReady) {
    track(
      event,
      {
        ...baseEventDetail,
        ...trackDetail,
      },
      isInActionDetail
    )
  }
}
